export default token => {
  const content = token.split(".")[1];
  const string = new Buffer(content, "base64").toString();
  return JSON.parse(string);
};
